// extracted by mini-css-extract-plugin
export default {"container":"container__n5S6h","btn":"btn__vADAL","multi-posts-actions":"multi-posts-actions__bW8iJ","multiPostsActions":"multi-posts-actions__bW8iJ"};